export default __webpack_public_path__ + "static/media/Illustration_1.96704df3.svg";